import React from 'react';
import { Play } from 'lucide-react';

// Atomic States
import { PlannedWorkoutState } from './performance/PlannedWorkoutState';
import { CompletedWorkoutState } from './performance/CompletedWorkoutState';
import { ActiveWorkoutState } from './performance/ActiveWorkoutState';

interface PerformanceBodyProps {
    data: any;
    template: any;
    updatePerformanceLog: (logId: string, field: string, value: any) => void;
    onStartTracker?: () => void;
}

/**
 * PerformanceBody: Specialized domain editor for Workout/Performance events.
 * REFACTORED: Decomposed into status-aware atomic states.
 */
export const PerformanceBody: React.FC<PerformanceBodyProps> = ({ data, template, updatePerformanceLog, onStartTracker }) => {
    const { performanceLogs = [], status } = data;
    const isCompleted = status === 'COMPLETED';
    const isPlanned = status === 'PLANNED';
    const isActive = status === 'ACTIVE';

    return (
        <div className="animate-in fade-in slide-in-from-top-2">
            
            {/* TACTICAL BRIDGE: OPEN TRACKER */}
            {(isPlanned || isCompleted) && data.programDayId && (
                <button 
                    onClick={onStartTracker}
                    style={{ 
                        all: 'unset', width: '100%', height: '54px', borderRadius: '12px', 
                        border: '1px solid #f29b1144', backgroundColor: 'rgba(242, 155, 17, 0.05)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px',
                        marginBottom: '30px', cursor: 'pointer', transition: 'all 0.2s'
                    }}
                    className="hover-glow"
                >
                    <Play size={18} color="#f29b11" fill="#f29b11" />
                    <span style={{ fontSize: '13px', fontWeight: '900', color: '#f29b11', letterSpacing: '1px' }}>
                        OPEN HIGH-FIDELITY TRACKER
                    </span>
                </button>
            )}

            {isPlanned && <PlannedWorkoutState template={template} />}
            
            {isCompleted && (
                <CompletedWorkoutState 
                    performanceLogs={performanceLogs} 
                    updatePerformanceLog={updatePerformanceLog} 
                />
            )}

            {isActive && <ActiveWorkoutState />}
        </div>
    );
};
